(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
$(function(){
  $('.vc-collection-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: "linear",
    slidesToShow: 4,
    swipe: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    allowTouchMove: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          speed: 6000,
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept"] && !Shopify.designMode) return;
  try {
    
  $(function(){
    function checkVisibility() {
      $('.parallax').each(function() {
        var $element = $(this);
        var bounds = this.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0) {
          $element.addClass('move');
        } else {
          $element.removeClass('move');
        }
      });
      $('.parallax-2').each(function() {
        var $element = $(this);
        var bounds = this.getBoundingClientRect();

        if (bounds.top < window.innerHeight && bounds.bottom > 0) {
          $element.addClass('move');
        } else {
          $element.removeClass('move');
        }
      });
    }

    $(window).scroll(function (){
      checkVisibility();
      var scrollTop = $(window).scrollTop();
      $('.parallax.move').css({'transform':'translateY(' + scrollTop * -0.05 + 'px)'});
      $('.parallax-2.move').css({'transform':'translateY(' + scrollTop * -0.1 + 'px)'});

      $('.vc-about__img').each(function() {
        var windowTop = $(window).scrollTop();
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var windowBottom = windowTop + $(window).height();

        if (elementBottom > windowTop && elementTop < windowBottom) {
            // 要素が画面内にある場合
            var visiblePart = Math.min(windowBottom, elementBottom) - Math.max(windowTop, elementTop);
            var percentageVisible = visiblePart / $(this).outerHeight();
            $(this).css('opacity', percentageVisible);
        } else if (elementTop < windowBottom) {
            // 要素が上にスクロールされて見えなくなる前
            $(this).css('opacity', 0);
        }
      });
    });

    $(window).on('load', function(){
      checkVisibility();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $(".fv-slider")
      // .on("init", function (event, slick) {
      //   $(this).append('<div class="slick-num u-en"><div class="slick-num__inner"><span class="now-count"></span><span class="all-count"></span></div></div>');
      //   $(".now-count").text((slick.currentSlide + 1).toString().padStart(2, '0'));
      //   $(".all-count").text(slick.slideCount.toString().padStart(2, '0'));
      // })
      .slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        speed: 1500,
        arrows: false,
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $(".now-count").text((nextSlide + 1).toString().padStart(2, '0'));
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
